import { GET_ALL_ADMIN_WALLET_DATA, GET_ALL_ADMIN_WALLET_DATA_SUCCCESS, GET_ALL_NAVISION_DATA_ERROR, GET_ALL_WALLET_REFUND_DATA, GET_ALL_WALLET_REFUND_DATA_SUCCCESS } from "../actionTypes";

export const getAllAdminWalletsData = (setTotalData,settotalPage,getCount) => ({
  type: GET_ALL_ADMIN_WALLET_DATA,
  payload: { setTotalData,settotalPage,getCount } 
});

export const getAllAdminWalletsDataSuccess = (data) => ({
  type: GET_ALL_ADMIN_WALLET_DATA_SUCCCESS,
  payload: data,
});

export const getAllAdminWalletsDataError = (error) => ({
  type: GET_ALL_NAVISION_DATA_ERROR,
  payload: error,
});

export const getAllWalletRefundData = (setTotalData,settotalPage,getCount) => ({
  type: GET_ALL_WALLET_REFUND_DATA,
  payload: { setTotalData,settotalPage,getCount } 
});

export const getAllWalletRefundDataSuccess = (data) => ({
  type: GET_ALL_WALLET_REFUND_DATA_SUCCCESS,
  payload: data,
});

export const getAllWalletRefundDataError = (error) => ({
  type: GET_ALL_NAVISION_DATA_ERROR,
  payload: error,
});


